import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-2xl font-bold font-heading text-primary-400">
                  68<span className="text-accent-400">影院</span>
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                68影院是专业的在线电影内容平台，提供最新最全的高清电影资源。无论你喜欢什么类型的电影，这里都能满足你的观影需求。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">电影分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 5).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">更多分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(5).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  品牌介绍
                </Link>
                <a
                  href="/about#contact"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  联系我们
                </a>
                <a
                  href="/about#faq"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  常见问题
                </a>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700 text-background-200 hover:bg-primary-500 transition-colors"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700 text-background-200 hover:bg-primary-500 transition-colors"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700 text-background-200 hover:bg-primary-500 transition-colors"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 68影院 Cinema68.com 版权所有 | <strong>68影院</strong> - <strong>电影大全</strong> | <strong>最新电影</strong>高清免费在线观看
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}